import React from 'react';
import { isEmpty, omit } from 'lodash';
import { style, classes } from 'typestyle';
import { resolvePath } from 'src/cdn';
import noImagePath from 'src/common-ui/images/noimage.jpg';
import { useStore } from 'react-redux';
import { AppState } from 'src/store';
import Skeleton from '@material-ui/lab/Skeleton';
export interface CenteredImageProps {
  src?: string;
  width: number;
  height: number | string;
  extraContainerClass?: string;
  extraImgProps?: Record<string, any>;
  printMode?: boolean;
}
const styles = {
  image: style({
    $debugName: 'CenteredImage',
    maxWidth: '100%',
    maxHeight: '100%',
    display: 'inline-block',
    verticalAlign: 'middle',
  }),
  makeImageContainer: (width: number, height: number | string) =>
    style({
      width: width,
      height: height,
      lineHeight: typeof height === 'number' ? `${height}px` : height,
      textAlign: 'center',
    }),
};

const noImage = resolvePath(noImagePath);

const CenteredImage = (props: CenteredImageProps) => {
  const { src, width, height, extraImgProps, extraContainerClass } = props;
  const store = useStore<AppState>()
  const printMode = store.getState().print.isPrintMode;
  // do not want to pass isBlankCard flag onto <img> element below
  const filteredExtraImgProps = omit(extraImgProps, 'isBlankCard');

  if (extraImgProps?.isBlankCard) {
    return null;
  }

  return (
    <div className={classes(styles.makeImageContainer(width, height), extraContainerClass)}>
      {isEmpty(src) && !printMode ? (
        <Skeleton variant="rect" className={styles.image} animation={'wave'} width={width} height={height} />
      ) : (
        <img src={src || noImage} alt="" className={styles.image} {...filteredExtraImgProps} />
      )}
    </div>
  );
};

export default CenteredImage;
